import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import svAuth from "../svAuth"

// Cristalina backend — separate base URL and token from the commissioning API.
export const cristalinaApi = createApi({
    reducerPath: "cristalinaApi",
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_CRISTALINA_BASE_URL || "https://sit.cristalina.statiq.in",
        prepareHeaders: headers => {
            const token = svAuth.token()
            if (token && !headers.has("otp-Token")) {
                headers.set("Auth-Token", token)
            }
            return headers
        },
    }),
    endpoints: () => ({}),
    tagTypes: ["SvVisits", "SvComments"],
})
